import { render } from "./goodsRestrictions.vue?vue&type=template&id=5fa8a7f7&scoped=true"
import script from "./goodsRestrictions.vue?vue&type=script&lang=js"
export * from "./goodsRestrictions.vue?vue&type=script&lang=js"

import "./goodsRestrictions.vue?vue&type=style&index=0&id=5fa8a7f7&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa8a7f7"]])

export default __exports__